export let KeyboardConstants = function (KeyboardConstants) {
  KeyboardConstants["SPACE"] = " ";
  KeyboardConstants["ENTER"] = "Enter";
  KeyboardConstants["ARROW_UP"] = "ArrowUp";
  KeyboardConstants["ARROW_DOWN"] = "ArrowDown";
  KeyboardConstants["ARROW_LEFT"] = "ArrowLeft";
  KeyboardConstants["ARROW_RIGHT"] = "ArrowRight";
  KeyboardConstants["TAB"] = "Tab";
  KeyboardConstants["ESCAPE"] = "Escape";
  KeyboardConstants["SHIFT"] = "Shift";
  KeyboardConstants["CONTROL"] = "Control";
  KeyboardConstants["ALT"] = "Alt";
  KeyboardConstants["META"] = "Meta";
  KeyboardConstants["BACKSPACE"] = "Backspace";
  return KeyboardConstants;
}({});
export const ConfirmAction = [KeyboardConstants.SPACE, KeyboardConstants.ENTER];
//# sourceMappingURL=keyboard-constants.js.map